import {useState} from 'react';
import {Modal, Button, Row, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencil, faTimes} from '@fortawesome/pro-light-svg-icons';
import {faSpinnerThird} from '@fortawesome/pro-duotone-svg-icons';
import Form from 'react-bootstrap/Form';
import {useDeviceMutations} from './deviceMutations';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';
import cx from 'classnames';
import {NIL} from 'uuid';
import {useCustomerContext} from '../../lib/context/customerContext';

export const FirmwareAssignmentModal = (props) => {
  const {
    row: {
      serial_number,
      firmware_id,
      firmware,
      reported_firmware_id,
      reported_firmware,
      ota_state,
      ota_progress,
      is_active,
    }
  } = props ?? {};
  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => is_active && setShow(true);
  
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const handleHideCancelConfirm = (e) => {
    e?.stopPropagation();
    setShowCancelConfirm(false);
  }
  const handleShowCancelConfirm = (e) =>  {
    e?.stopPropagation();
    setShowCancelConfirm(true);
  }
  const {success, error} = props.alerts;
  const {stopOTA} = useDeviceMutations();
  const {hasPermission} = useCustomerContext();

  const onCancel = async (e) => {
    e?.stopPropagation();
    handleHideCancelConfirm();
    const stopDeviceOTA = await stopOTA({variables:{serial_number}});
    
    if(stopDeviceOTA.errors) {
      error({title: 'Cancel Firmware Update', msg: 'Error canceling firmware update.'});
    } else {
      success({title: 'Cancel Firmware Update', msg: 'Firmware update canceled.'});
      handleClose();      
    }
  }

  // RBAC: cancelling an in-progress OTA is part of the same single-device
  // firmware control surface as SAFECASE_SINGLE_OTA (gated elsewhere in
  // safeCaseDetails.jsx). Not explicitly named in the RBAC sheet's UI
  // Treatment column - this is an inference, not a literal rule, so flag
  // for confirmation rather than treating it as settled.
  const canCancelOTA = hasPermission('SAFECASE_SINGLE_OTA');
  const showCancel = canCancelOTA && (ota_state === "in_progress" || ( (reported_firmware_id !== firmware_id) && (firmware_id !== NIL && reported_firmware_id !== NIL ) ));
  const showSpinner = ota_state === "in_progress";
  
  return (
    <>
      { ota_state === 'in_progress' ?
        <>
          <p className="privoro-white me-2">
            {ota_progress}%
          </p> 
          { showCancel && <FontAwesomeIcon onClick={handleShowCancelConfirm} color="red" icon={faTimes} size="lg" className="me-2 pointer"/>}
          { showSpinner && <FontAwesomeIcon icon={faSpinnerThird} size="lg" className="me-2 fa-spin"/>}
          <span>{firmware?.version ?? ''}</span>
        </>
        :
        <>
          { showCancel && <FontAwesomeIcon onClick={handleShowCancelConfirm} color="red" icon={faTimes} size="lg" className="me-2 pointer"/>}
          <span>{reported_firmware?.version ?? ''}</span>
        </>
      }
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showCancelConfirm}
        onHide={handleHideCancelConfirm}
        animation={false}
      >
        <Modal.Header >
          <Modal.Title>Cancel Firmware Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row>
          <Col>
            <b>Cancel Firmware Update From {reported_firmware?.version ?? "unknown"} To {firmware?.version ?? "unknown"}?</b>
          </Col>
        </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button onClick={handleHideCancelConfirm} variant="secondary">Cancel</Button> 
            <Button onClick={onCancel} className="ms-2">Confirm</Button> 
          </div>
        </Modal.Footer>
      </Modal>      
    </>
  );
}

export default compose(
  withAlerts
)(FirmwareAssignmentModal);
